import { stringify } from 'query-string';
import { sortOrderTypes } from 'types/shared';

export default getShortFormVideoActualityUrl;

/**
 * This URL constructor creates an URL for ShortFormVideo.
 * @param {object} args URL constructor arguments
 * @returns {string} ShortFormVideo URL for tracks and artists
 */

interface IProps {
  expand: string;
  limit?: number;
  offset?: number;
  platform?: number;
  sortBy?: string;
  sortOrder?: sortOrderTypes;
}

function getShortFormVideoActualityUrl(options: IProps): string {
  const params = stringify(options);

  return `/api/shortFormVideo/actuality${params !== '' ? `?${params}` : ''}`;
}
